import { render, staticRenderFns } from "./TemplateGeneratorSpace.vue?vue&type=template&id=21dde2d9&"
import script from "./TemplateGeneratorSpace.vue?vue&type=script&lang=js&"
export * from "./TemplateGeneratorSpace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports